import {webNet} from "@/request";

// 获取轮播图列表的方法
export const getBannerList = () => {
    // 设置参数
    let params = new URLSearchParams()
    return webNet.request({
        params: {},
        data: params,
        method: 'post',
        url: '/web/get/banner/list',
    })
}
